import { Platform } from 'react-native'

export type Coords = { latitude: number; longitude: number }

/**
 * Get the device's current position. Works on web (navigator.geolocation) and native (expo-location).
 * Returns null if permission denied, unavailable, or error.
 */
export async function getCurrentPosition(): Promise<Coords | null> {
  if (Platform.OS === 'web') {
    if (typeof navigator === 'undefined' || !navigator.geolocation) return null
    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
        () => resolve(null),
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 }
      )
    })
  }

  try {
    const { getCurrentPositionAsync, requestForegroundPermissionsAsync } = await import(
      'expo-location'
    )
    const { status } = await requestForegroundPermissionsAsync()
    if (status !== 'granted') return null
    const location = await getCurrentPositionAsync({ accuracy: 6 })
    if (!location?.coords) return null
    return {
      latitude: location.coords.latitude,
      longitude: location.coords.longitude,
    }
  } catch {
    return null
  }
}
